// Neutral placeholder product images.
// Used while we wait for supplier permission or shoot our own product photos.
// Swap these out per-product as real photography becomes available.
import placeholderCleaner from "@/assets/products/placeholder-cleaner.jpg";
import placeholderAdhesive from "@/assets/products/placeholder-adhesive.jpg";
import placeholderThread from "@/assets/products/placeholder-thread.jpg";
import placeholderHardware from "@/assets/products/placeholder-hardware.jpg";
import placeholderBoating from "@/assets/products/placeholder-boating.jpg";

export const PRODUCT_PLACEHOLDERS = {
  cleaner: placeholderCleaner,
  adhesive: placeholderAdhesive,
  thread: placeholderThread,
  hardware: placeholderHardware,
  boating: placeholderBoating,
} as const;
